import { css, html } from 'lit';
import { customElement } from 'lit/decorators';
import { commonFormStyles, commonPopupMobileStyle, commonPopupStyle } from '../../styles/common-style';
import { DeviceAwareComponent } from '../components/device-aware-component';
import { CheckmarkGreen } from '../icons/icons';
import { eventBus } from '@APP/utils/event-bus';
import { Events } from '@APP/events/app-events';
import { t } from '../../utils/locale';

@customElement('call-back-requested-popup')
export class CallBackRequestedPopup extends DeviceAwareComponent {
  static get baseStyles() {
    return [
      commonPopupStyle,
      commonFormStyles,
      css`
        .header {
          display: flex;
          align-items: center;
          gap: 1.25rem;
        }
        /* CheckmarkGreen is 25x26 — size by height so the circle stays round. */
        .header svg {
          height: 3rem;
          width: auto;
          flex: none;
        }
        h1.title {
          font-size: var(--font-size-h2, 4rem);
          font-weight: 700;
          margin: 0;
        }
        .message {
          font-weight: 400;
          color: var(--c-text);
          max-width: var(--message-max-width, 39rem);
          margin-block-start: 1.5rem;
        }
        .actions {
          display: flex;
          align-items: center;
        }

        /* Same copied funnel button classes as get-a-call-back-popup — they
           live in popup-manager's / lh-dropdown's shadow roots and can't reach
           this one. Keep in sync with those sources. */
        .popup-btn {
          cursor: pointer;
          border: 2px solid var(--c-emphasize-sec);
          min-width: 20rem;
          margin: 2rem 0;
          text-align: center;
          font-size: 2.5rem;
          padding: 0 2rem;
          min-height: 6.25rem;
          width: max-content;
          place-self: var(--popup-place-self, end start);
        }

        .second-popup-btn {
          border: 2px solid var(--c-button-hover);
          color: var(--c-emphasize-sec);
          background-color: white;
          margin-right: 1rem;
          height: 6.25rem;
          padding: 0 2rem;
          font-size: 2.5rem;
          text-align: center;
        }

        /* Border matches the fill (like the funnel's #btn-next) so the
           filled pill shows no outline ring; .dropbtn:hover swaps both. */
        button.dropbtn {
          font-weight: 600;
          border: 2px solid var(--c-emphasize-sec);
          background: var(--btn-pri-bg);
          color: var(--btn-pri-text);
          border-radius: 5rem;
          padding-block: 1rem;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .dropbtn:hover {
          background-color: var(--c-button-hover);
          border: 2px solid var(--c-button-hover);
        }
      `,
    ];
  }

  static get desktopStyles() {
    return [css`
      h1.title {
        margin-block: 0;
      }
    `];
  }

  static get mobileStyles() {
    return [
      commonPopupMobileStyle,
      css`
        .actions button {
          width: 100%;
        }
      `,
    ];
  }

  private _onOk = () => {
    eventBus().emit(Events.Type.PopupClose);
  };

  private renderBody() {
    return html`
      <div class="header">
        ${CheckmarkGreen}
        <h1 class="title">${t('T_Call_Back_Requested_Title')}</h1>
      </div>
      <h2 class="message">${t('T_Call_Back_Requested_Text')}</h2>
      <div class="actions">
        <button
          class="second-popup-btn dropbtn popup-btn"
          type="button"
          style="min-width:14rem;"
          @click=${this._onOk}
        >
          ${t('T_Call_Back_Requested_Ok')}
        </button>
      </div>
    `;
  }

  renderMobileLayout() {
    return html`<div class="col-1">${this.renderBody()}</div>`;
  }

  renderDesktopLayout() {
    return html`
      <div class="grid-container">
        <div class="col-1"></div>
        <div class="col-2">${this.renderBody()}</div>
      </div>
    `;
  }

  renderContent() {
    return this.userDevice === 'desktop' ? this.renderDesktopLayout() : this.renderMobileLayout();
  }
}
